import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_company_down",
  "use": "icon-bashboard_company_down-usage",
  "viewBox": "0 0 82 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 82 26\" id=\"icon-bashboard_company_down\">\n<polygon points=\"81.5,25.9 80.9,19.2 78.3,21.5 54.4,2.5 27.8,22.2 1.8,0.1 0.5,1.6 27.7,24.7 54.4,5 76.9,22.8 74.6,25 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol